const tagCategory = {
  "A": "ベース運用",
  "B": "ミッション（電柱接触）",
  "C": "ミッション（仮復旧）"
};

const seasonTag = [
  {
    "value": "A0",
    "label": "A0",
    "tip": "A0: なし＝A1-1～A2-3の目的以外で閲覧した結果、特に不良がなかったもの）"
  },
  {
    "value": "A1-1",
    "label": "A1-1",
    "tip": "A1-1: お客様要請＝出向回避（計画作業振替、設計依頼を含む）"
  },
  {
    "value": "A1-2",
    "label": "A1-2",
    "tip": "A1-2: お客様要請＝緊急性を確認したため、現場出向"
  },
  {
    "value": "A1-3",
    "label": "A1-3",
    "tip": "A1-3: お客様要請＝写真では正確に判定できないため、現場出向"
  },
  {
    "value": "A2-1",
    "label": "A2-1",
    "tip": "A2-1: 予防保全＝机上管理（計画作業振替、設計依頼を含む）"
  },
  {
    "value": "A2-2",
    "label": "A2-2",
    "tip": "A2-2: 予防保全＝緊急性を確認したため、現場出向"
  },
  {
    "value": "A2-3",
    "label": "A2-3",
    "tip": "A2-3: 予防保全＝写真では正確に判定できないため、現場出向"
  },
];

const missionTagB =  [
  {
    "value": "B1-1",
    "label": "B1-1",
    "tip": "B1-1: 電柱接触痕から、安全性を確認したため、出向回避"
  },
  {
    "value": "B1-2",
    "label": "B1-2",
    "tip": "B1-2: 電柱接触痕から、緊急性を確認したため、現場出向"
  },
  {
    "value": "B1-3",
    "label": "B1-3",
    "tip": "B1-3: 写真では正確に判定できないため、現場出向"
  },
];

const missionTagC =  [
  {
    "value": "C1-1",
    "label": "C1-1",
    "tip": "C1-1: 仮復旧箇所に段差が無いことを確認したため、出向回避"
  },
  {
    "value": "C1-2",
    "label": "C1-2",
    "tip": "C1-2: 仮復旧箇所に段差が有ることを確認したため、現場出向"
  },
  {
    "value": "C1-3",
    "label": "C1-3",
    "tip": "C1-3: 写真では正確に判定できないため、現場出向"
  },
];

const reportTag =  [
  {
    "value": "営巣情報",
    "label": "営巣情報",
    "tip": "営巣情報"
  },
  {
    "value": "台風情報",
    "label": "台風情報",
    "tip": "台風情報"
  },
  {
    "value": "樹木情報",
    "label": "樹木情報",
    "tip": "樹木情報"
  },
  {
    "value": "電柱接触情報",
    "label": "電柱接触情報",
    "tip": "電柱接触情報"
  },
  {
    "value": "電柱垂れ情報",
    "label": "電柱垂れ情報",
    "tip": "電柱垂れ情報"
  },
  {
    "value": "飛来物情報",
    "label": "飛来物情報",
    "tip": "飛来物情報"
  },
  {
    "value": "その他",
    "label": "その他",
    "tip": "その他"
  },
];

const reportTag2 =  [
  {
    "value": "対象無し",
    "label": "対象無し",
    "tip": " 対象物が存在しない"
  },
  {
    "value": "位置ズレ",
    "label": "位置ズレ",
    "tip": "対象物がマップ上の位置と大きくズレている"
  },
  {
    "value": "撮影困難",
    "label": "撮影困難",
    "tip": "対象物が撮影できる場所にない（私有地内、山間部など）"
  },
  {
    "value": "撮影危険",
    "label": "撮影危険",
    "tip": "撮影に危険が伴う場所に対象物がある（車道に乗り出さないと撮影できない場所など）"
  },
  {
    "value": "その他",
    "label": "その他",
    "tip": "その他"
  },
  {
    "value": "営巣",
    "label": "営巣",
    "tip": "電柱に鳥の巣が存在している"
  },
  {
    "value": "樹木",
    "label": "樹木",
    "tip": "電柱に植物が接触している"
  },
  {
    "value": "飛来物",
    "label": "飛来物",
    "tip": "電柱や電線に物が引っかかっている（布団・ハンガー・傘・レジ袋等）"
  },
  {
    "value": "番札",
    "label": "番札",
    "tip": "電柱に電柱番号プレートが付いていない、または破損している"
  },
  {
    "value": "電垂れ",
    "label": "電垂れ",
    "tip": "電線が垂れ下がっている、切れている、手に届く位置にある"
  },
  {
    "value": "換気孔破損",
    "label": "換気孔破損",
    "tip": "電柱周辺（電柱から半径約3ｍ）のアスファルトに1㎝以上の段差がある"
  },
  {
    "value": "換気孔段差",
    "label": "換気孔段差",
    "tip": "電柱の根本に1㎝以上の隙間や穴がある"
  },
  {
    "value": "電柱段差",
    "label": "電柱段差",
    "tip": "換気口が一部欠けている、破損している"
  },
  {
    "value": "電柱地際",
    "label": "電柱地際",
    "tip": "換気口が傾いている、または地面との間に1㎝以上の段差がある"
  },
  {
    "value": "番号",
    "label": "番号",
    "tip": "地上設備の番号がない、または表示が薄い"
  },
  {
    "value": "落書き",
    "label": "落書き",
    "tip": "地上設備に落書きがしてある"
  },
  {
    "value": "錆",
    "label": "錆",
    "tip": "地上設備が錆びている"
  },
];

const reportResultTagTemp =  [
  {
    "level": "-",
    "value": "-（未確認）",
    "label": "-（未確認）",
    "tip": ""
  },
  {
    "level": "0-1",
    "value": "ツルツタLv.0−1",
    "label": "ツルツタLv.0−1",
    "tip": "ツタなし"
  },
  {
    "level": "0-2",
    "value": "ツルツタLv.0-2",
    "label": "ツルツタLv.0-2",
    "tip": "写真判別不可"
  },
  {
    "level": "1-1",
    "value": "ツルツタLv.1−1",
    "label": "ツルツタLv.1−1",
    "tip": "低圧未満へのツタ"
  },
  {
    "level": "1-2",
    "value": "ツルツタLv.1−2",
    "label": "ツルツタLv.1−2",
    "tip": "低圧未満への枯れツタ"
  },
  {
    "level": "1-3",
    "value": "ツルツタLv.1−3",
    "label": "ツルツタLv.1−3",
    "tip": "低圧単独柱・付属柱へのツタ"
  },
  {
    "level": "2-1",
    "value": "ツルツタLv.2ｰ1",
    "label": "ツルツタLv.2ｰ1",
    "tip": "低圧以上へのツタ"
  },
  {
    "level": "2-2",
    "value": "ツルツタLv.2−2",
    "label": "ツルツタLv.2−2",
    "tip": "低圧以上への枯れツタ"
  },
  {
    "level": "2-3",
    "value": "ツルツタLv.2−3",
    "label": "ツルツタLv.2−3",
    "tip": "低圧以上への竹"
  },
  {
    "level": "2-4",
    "value": "ツルツタLv.2−4",
    "label": "ツルツタLv.2−4",
    "tip": "低圧以上への樹木"
  },
  {
    "level": "3-1",
    "value": "ツルツタLv.3ｰ1",
    "label": "ツルツタLv.3ｰ1",
    "tip": "高圧、変圧器へのツタ"
  },
  {
    "level": "3-2",
    "value": "ツルツタLv.3ｰ2",
    "label": "ツルツタLv.3ｰ2",
    "tip": "高圧、変圧器への枯れツタ"
  },
  {
    "level": "3-3",
    "value": "ツルツタLv.3ｰ3",
    "label": "ツルツタLv.3ｰ3",
    "tip": "高圧、変圧器への竹"
  },
  {
    "level": "3-4",
    "value": "ツルツタLv.3ｰ4",
    "label": "ツルツタLv.3ｰ4",
    "tip": "高圧、変圧器への樹木"
  },
];

const reportResultTagTemp2 =  [
  { level: "-", value: "-（未確認）", label: "-（未確認）", tip: "" },
  { level: "0-1", value: "Lv.0-1:ツル・竹・樹木なし", label: "Lv.0-1", tip: "ツル・竹・樹木なし" },
  { level: "0-2", value: "Lv.0-2:写真判別不可", label: "Lv.0-2", tip: "写真判別不可" },
  { level: "0-3", value: "Lv.0-3:NTT単独柱、他社設備", label: "Lv.0-3", tip: "NTT単独柱、他社設備" },

  { level: "1-1", value: "Lv.1-1:弱電未満へのツタ", label: "Lv.1-1", tip: "弱電未満へのツタ" },
  { level: "1-2", value: "Lv.1-2:弱電未満への枯れツタ", label: "Lv.1-2", tip: "弱電未満への枯れツタ" },
  { level: "1-3", value: "Lv.1-3:支線柱へのツタ", label: "Lv.1-3", tip: "支線柱へのツタ" },

  { level: "2-1", value: "Lv.2-1:弱電以上へのツタ", label: "Lv.2-1", tip: "弱電以上へのツタ" },
  { level: "2-2", value: "Lv.2-2:弱電以上への枯れツタ", label: "Lv.2-2", tip: "弱電以上への枯れツタ" },
  { level: "2-3", value: "Lv.2-3:弱電以上への竹", label: "Lv.2-3", tip: "弱電以上への竹" },
  { level: "2-4", value: "Lv.2-4:弱電以上への樹木", label: "Lv.2-4", tip: "弱電以上への樹木" },
  // { level: "2-5", value: "Lv.2-5:営巣", label: "Lv.2-5", tip: "営巣" },

  { level: "3-1", value: "Lv.3-1:ツタ", label: "Lv.3-1", tip: "ツタ" },
  { level: "3-1-1", value: "Lv.3-1:ツタ 腕金", label: "Lv.3-1", tip: "ツタ 腕金", indent: true },
  { level: "3-1-2", value: "Lv.3-1:ツタ アームタイ", label: "Lv.3-1", tip: "ツタ アームタイ", indent: true },
  { level: "3-1-3", value: "Lv.3-1:ツタ 支線", label: "Lv.3-1", tip: "ツタ 支線", indent: true },
  { level: "3-1-4", value: "Lv.3-1:ツタ 本柱", label: "Lv.3-1", tip: "ツタ 本柱", indent: true },
  { level: "3-1-5", value: "Lv.3-1:ツタ 変圧器", label: "Lv.3-1", tip: "ツタ 変圧器", indent: true },

  { level: "3-2", value: "Lv.3-2:枯れツタ", label: "Lv.3-2", tip: "枯れツタ" },
  { level: "3-2-1", value: "Lv.3-2:枯れツタ 腕金", label: "Lv.3-2", tip: "枯れツタ 腕金", indent: true },
  { level: "3-2-2", value: "Lv.3-2:枯れツタ アームタイ", label: "Lv.3-2", tip: "枯れツタ アームタイ", indent: true },
  { level: "3-2-3", value: "Lv.3-2:枯れツタ 支線", label: "Lv.3-2", tip: "枯れツタ 支線", indent: true },
  { level: "3-2-4", value: "Lv.3-2:枯れツタ 本柱", label: "Lv.3-2", tip: "枯れツタ 本柱", indent: true },
  { level: "3-2-5", value: "Lv.3-2:枯れツタ 変圧器", label: "Lv.3-2", tip: "枯れツタ 変圧器", indent: true },

  { level: "3-3", value: "Lv.3-3:竹", label: "Lv.3-3", tip: "竹" },
  { level: "3-3-1", value: "Lv.3-3:竹 腕金", label: "Lv.3-3", tip: "竹 腕金", indent: true },
  { level: "3-3-2", value: "Lv.3-3:竹 アームタイ", label: "Lv.3-3", tip: "竹 アームタイ", indent: true },
  { level: "3-3-3", value: "Lv.3-3:竹 支線", label: "Lv.3-3", tip: "竹 支線", indent: true },
  { level: "3-3-4", value: "Lv.3-3:竹 本柱", label: "Lv.3-3", tip: "竹 本柱", indent: true },
  { level: "3-3-5", value: "Lv.3-3:竹 変圧器", label: "Lv.3-3", tip: "竹 変圧器", indent: true },

  { level: "3-4", value: "Lv.3-4:樹木（枝葉）", label: "Lv.3-4", tip: "樹木（枝葉）" },
  { level: "3-4-1", value: "Lv.3-4:樹木（枝葉） 腕金", label: "Lv.3-4", tip: "樹木（枝葉） 腕金", indent: true },
  { level: "3-4-2", value: "Lv.3-4:樹木（枝葉） アームタイ", label: "Lv.3-4", tip: "樹木（枝葉） アームタイ", indent: true },
  { level: "3-4-3", value: "Lv.3-4:樹木（枝葉） 支線", label: "Lv.3-4", tip: "樹木（枝葉） 支線", indent: true },
  { level: "3-4-4", value: "Lv.3-4:樹木（枝葉） 本柱", label: "Lv.3-4", tip: "樹木（枝葉） 本柱", indent: true },
  { level: "3-4-5", value: "Lv.3-4:樹木（枝葉） 変圧器", label: "Lv.3-4", tip: "樹木（枝葉）変圧器", indent: true },

  { level: "3-5", value: "Lv.3-5:樹木（幹）", label: "Lv.3-5", tip: "樹木（幹）" },
  { level: "3-5-1", value: "Lv.3-5:樹木（幹） 腕金", label: "Lv.3-5", tip: "樹木（幹） 腕金", indent: true },
  { level: "3-5-2", value: "Lv.3-5:樹木（幹） アームタイ", label: "Lv.3-5", tip: "樹木（幹） アームタイ", indent: true },
  { level: "3-5-3", value: "Lv.3-5:樹木（幹） 支線", label: "Lv.3-5", tip: "樹木（幹） 支線", indent: true },
  { level: "3-5-4", value: "Lv.3-5:樹木（幹） 本柱", label: "Lv.3-5", tip: "樹木（幹） 本柱", indent: true },
  { level: "3-5-5", value: "Lv.3-5:樹木（幹） 変圧器", label: "Lv.3-5", tip: "樹木（幹） 変圧器", indent: true },

  // { level: "3-6", value: "Lv.3-6:営巣", label: "Lv.3-6", tip: "営巣" },
  // { level: "3-6-1", value: "Lv.3-6:営巣 腕金", label: "Lv.3-6", tip: "営巣 腕金", indent: true },
  // { level: "3-6-2", value: "Lv.3-6:営巣 アームタイ", label: "Lv.3-6", tip: "営巣 アームタイ", indent: true },
  // { level: "3-6-3", value: "Lv.3-6:営巣 支線", label: "Lv.3-6", tip: "営巣 支線", indent: true },
  // { level: "3-6-4", value: "Lv.3-6:営巣 本柱", label: "Lv.3-6", tip: "営巣 本柱", indent: true },
  // { level: "3-6-5", value: "Lv.3-6:営巣 変圧器", label: "Lv.3-6", tip: "営巣 変圧器", indent: true },

  // ---- Lv.4 親＋子（indent: true） ----
  { level: "4-1", value: "Lv.4-1:ツタ", label: "Lv.4-1", tip: "ツタ" },
  { level: "4-1-1", value: "Lv.4-1:ツタ 高圧本線", label: "Lv.4-1", tip: "ツタ 高圧本線", indent: true },
  { level: "4-1-2", value: "Lv.4-1:ツタ PD", label: "Lv.4-1", tip: "ツタ PD", indent: true },
  { level: "4-1-3", value: "Lv.4-1:ツタ CH", label: "Lv.4-1", tip: "ツタ CH", indent: true },
  { level: "4-1-4", value: "Lv.4-1:ツタ AS", label: "Lv.4-1", tip: "ツタ AS", indent: true },
  { level: "4-1-5", value: "Lv.4-1:ツタ 放クラ", label: "Lv.4-1", tip: "ツタ 放クラ", indent: true },
  { level: "4-1-6", value: "Lv.4-1:ツタ カバー", label: "Lv.4-1", tip: "ツタ カバー", indent: true },

  { level: "4-2", value: "Lv.4-2:枯れツタ", label: "Lv.4-2", tip: "枯れツタ" },
  { level: "4-2-1", value: "Lv.4-2:枯れツタ 高圧本線", label: "Lv.4-2", tip: "枯れツタ 高圧本線", indent: true },
  { level: "4-2-2", value: "Lv.4-2:枯れツタ PD", label: "Lv.4-2", tip: "枯れツタ PD", indent: true },
  { level: "4-2-3", value: "Lv.4-2:枯れツタ CH", label: "Lv.4-2", tip: "枯れツタ CH", indent: true },
  { level: "4-2-4", value: "Lv.4-2:枯れツタ AS", label: "Lv.4-2", tip: "枯れツタ AS", indent: true },
  { level: "4-2-5", value: "Lv.4-2:枯れツタ 放クラ", label: "Lv.4-2", tip: "枯れツタ 放クラ", indent: true },
  { level: "4-2-6", value: "Lv.4-2:枯れツタ カバー", label: "Lv.4-2", tip: "枯れツタ カバー", indent: true },

  { level: "4-3", value: "Lv.4-3:竹", label: "Lv.4-3", tip: "竹" },
  { level: "4-3-1", value: "Lv.4-3:竹 高圧本線", label: "Lv.4-3", tip: "竹 高圧本線", indent: true },
  { level: "4-3-2", value: "Lv.4-3:竹 PD", label: "Lv.4-3", tip: "竹 PD", indent: true },
  { level: "4-3-3", value: "Lv.4-3:竹 CH", label: "Lv.4-3", tip: "竹 CH", indent: true },
  { level: "4-3-4", value: "Lv.4-3:竹 AS", label: "Lv.4-3", tip: "竹 AS", indent: true },
  { level: "4-3-5", value: "Lv.4-3:竹 放クラ", label: "Lv.4-3", tip: "竹 放クラ", indent: true },
  { level: "4-3-6", value: "Lv.4-3:竹 カバー", label: "Lv.4-3", tip: "竹 カバー", indent: true },

  { level: "4-4", value: "Lv.4-4:樹木（枝葉）", label: "Lv.4-4", tip: "樹木（枝葉）" },
  { level: "4-4-1", value: "Lv.4-4:樹木（枝葉） 高圧本線", label: "Lv.4-4", tip: "樹木（枝葉） 高圧本線", indent: true },
  { level: "4-4-2", value: "Lv.4-4:樹木（枝葉） PD", label: "Lv.4-4", tip: "樹木（枝葉） PD", indent: true },
  { level: "4-4-3", value: "Lv.4-4:樹木（枝葉） CH", label: "Lv.4-4", tip: "樹木（枝葉） CH", indent: true },
  { level: "4-4-4", value: "Lv.4-4:樹木（枝葉） AS", label: "Lv.4-4", tip: "樹木（枝葉） AS", indent: true },
  { level: "4-4-5", value: "Lv.4-4:樹木（枝葉） 放クラ", label: "Lv.4-4", tip: "樹木（枝葉） 放クラ", indent: true },
  { level: "4-4-6", value: "Lv.4-4:樹木（枝葉） カバー", label: "Lv.4-4", tip: "樹木（枝葉） カバー", indent: true },

  { level: "4-5", value: "Lv.4-5:樹木（幹）", label: "Lv.4-5", tip: "樹木（幹）" },
  { level: "4-5-1", value: "Lv.4-5:樹木（幹） 高圧本線", label: "Lv.4-5", tip: "樹木（幹） 高圧本線", indent: true },
  { level: "4-5-2", value: "Lv.4-5:樹木（幹） PD", label: "Lv.4-5", tip: "樹木（幹） PD", indent: true },
  { level: "4-5-3", value: "Lv.4-5:樹木（幹） CH", label: "Lv.4-5", tip: "樹木（幹） CH", indent: true },
  { level: "4-5-4", value: "Lv.4-5:樹木（幹） AS", label: "Lv.4-5", tip: "樹木（幹） AS", indent: true },
  { level: "4-5-5", value: "Lv.4-5:樹木（幹） 放クラ", label: "Lv.4-5", tip: "樹木（幹） 放クラ", indent: true },
  { level: "4-5-6", value: "Lv.4-5:樹木（幹） カバー", label: "Lv.4-5", tip: "樹木（幹） カバー", indent: true },

  // { level: "4-6", value: "Lv.4-6:営巣", label: "Lv.4-6", tip: "営巣" },
  // { level: "4-6-1", value: "Lv.4-6:営巣 高圧本線", label: "Lv.4-6", tip: "営巣 高圧本線", indent: true },
  // { level: "4-6-2", value: "Lv.4-6:営巣 PD", label: "Lv.4-6", tip: "営巣 PD", indent: true },
  // { level: "4-6-3", value: "Lv.4-6:営巣 CH", label: "Lv.4-6", tip: "営巣 CH", indent: true },
  // { level: "4-6-4", value: "Lv.4-6:営巣 AS", label: "Lv.4-6", tip: "営巣 AS", indent: true },
  // { level: "4-6-5", value: "Lv.4-6:営巣 放クラ", label: "Lv.4-6", tip: "営巣 放クラ", indent: true },
  // { level: "4-6-6", value: "Lv.4-6:営巣 カバー", label: "Lv.4-6", tip: "営巣 カバー", indent: true },
  { level: "4-7", value: "Lv.4-7:その他至急", label: "Lv.4-7", tip: "その他至急" },

  {
    "level": "0-1",
    "value": "ツルツタLv.0−1",
    "label": "ツルツタLv.0−1",
    "tip": "ツタなし（旧）"
  },
  {
    "level": "0-2",
    "value": "ツルツタLv.0-2",
    "label": "ツルツタLv.0-2",
    "tip": "写真判別不可（旧）"
  },
  {
    "level": "1-1",
    "value": "ツルツタLv.1−1",
    "label": "ツルツタLv.1−1",
    "tip": "低圧未満へのツタ（旧）"
  },
  {
    "level": "1-2",
    "value": "ツルツタLv.1−2",
    "label": "ツルツタLv.1−2",
    "tip": "低圧未満への枯れツタ（旧）"
  },
  {
    "level": "1-3",
    "value": "ツルツタLv.1−3",
    "label": "ツルツタLv.1−3",
    "tip": "低圧単独柱・付属柱へのツタ（旧）"
  },
  {
    "level": "2-1",
    "value": "ツルツタLv.2ｰ1",
    "label": "ツルツタLv.2ｰ1",
    "tip": "低圧以上へのツタ（旧）"
  },
  {
    "level": "2-2",
    "value": "ツルツタLv.2−2",
    "label": "ツルツタLv.2−2",
    "tip": "低圧以上への枯れツタ（旧）"
  },
  {
    "level": "2-3",
    "value": "ツルツタLv.2−3",
    "label": "ツルツタLv.2−3",
    "tip": "低圧以上への竹（旧）"
  },
  {
    "level": "2-4",
    "value": "ツルツタLv.2−4",
    "label": "ツルツタLv.2−4",
    "tip": "低圧以上への樹木（旧）"
  },
  {
    "level": "3-1",
    "value": "ツルツタLv.3ｰ1",
    "label": "ツルツタLv.3ｰ1",
    "tip": "高圧、変圧器へのツタ（旧）"
  },
  {
    "level": "3-2",
    "value": "ツルツタLv.3ｰ2",
    "label": "ツルツタLv.3ｰ2",
    "tip": "高圧、変圧器への枯れツタ（旧）"
  },
  {
    "level": "3-3",
    "value": "ツルツタLv.3ｰ3",
    "label": "ツルツタLv.3ｰ3",
    "tip": "高圧、変圧器への竹（旧）"
  },
  {
    "level": "3-4",
    "value": "ツルツタLv.3ｰ4",
    "label": "ツルツタLv.3ｰ4",
    "tip": "高圧、変圧器への樹木（旧）"
  },
];

const reportResultTagTip =  [
  {
    "level": "0-1",
    "value": "ツルツタLv.0−1",
    "label": "ツルツタLv.0−1",
    "tip": "ツルツタLv.0−1 : ツタなし"
  },
  {
    "level": "0-2",
    "value": "ツルツタLv.0-2",
    "label": "ツルツタLv.0-2",
    "tip": "ツルツタLv.0-2 : 写真判別不可"
  },
  {
    "level": "1-1",
    "value": "ツルツタLv.1−1",
    "label": "ツルツタLv.1−1",
    "tip": "ツルツタLv.1−1 | 低圧未満へのツタ"
  },
  {
    "level": "1-2",
    "value": "ツルツタLv.1−2",
    "label": "ツルツタLv.1−2",
    "tip": "ツルツタLv.1−2 : 低圧未満への枯れツタ"
  },
  {
    "level": "1-3",
    "value": "ツルツタLv.1−3",
    "label": "ツルツタLv.1−3",
    "tip": "ツルツタLv.1−3 : 低圧単独柱・付属柱へのツタ"
  },
  {
    "level": "2-1",
    "value": "ツルツタLv.2ｰ1",
    "label": "ツルツタLv.2ｰ1",
    "tip": "ツルツタLv.2ｰ1 : 低圧以上へのツタ"
  },
  {
    "level": "2-2",
    "value": "ツルツタLv.2−2",
    "label": "ツルツタLv.2−2",
    "tip": "ツルツタLv.2−2 : 低圧以上への枯れツタ"
  },
  {
    "level": "2-3",
    "value": "ツルツタLv.2−3",
    "label": "ツルツタLv.2−3",
    "tip": "ツルツタLv.2−3 : 低圧以上への竹"
  },
  {
    "level": "2-4",
    "value": "ツルツタLv.2−4",
    "label": "ツルツタLv.2−4",
    "tip": "ツルツタLv.2−4 : 低圧以上への樹木"
  },
  {
    "level": "3-1",
    "value": "ツルツタLv.3ｰ1",
    "label": "ツルツタLv.3ｰ1",
    "tip": "ツルツタLv.3ｰ1 : 高圧、変圧器へのツタ"
  },
  {
    "level": "3-2",
    "value": "ツルツタLv.3ｰ2",
    "label": "ツルツタLv.3ｰ2",
    "tip": "ツルツタLv.3ｰ2 : 高圧、変圧器への枯れツタ"
  },
  {
    "level": "3-3",
    "value": "ツルツタLv.3ｰ3",
    "label": "ツルツタLv.3ｰ3",
    "tip": "ツルツタLv.3ｰ3 : 高圧、変圧器への竹"
  },
  {
    "level": "3-4",
    "value": "ツルツタLv.3ｰ4",
    "label": "ツルツタLv.3ｰ4",
    "tip": "ツルツタLv.3ｰ4 : 高圧、変圧器への樹木"
  },
];

const resultTagNtt = [
  {
    "value": "true",
    "label": "合格",
  },
  {
    "value": "false",
    "label": "不合格",
  },
  {
    "value": "pending",
    "label": "保留",
  },
];

const resultTagNttOption = [
  {
    "value": null,
    "label": "全て",
  },
  {
    "value": "true",
    "label": "合格",
  },
  {
    "value": "false",
    "label": "不合格",
  },
  {
    "value": "pending",
    "label": "保留",
  },
];

const nttmeRejectReasons = [
  { label: "写真不鮮明（ピンボケ・遠距離 等）", value: "blurry_or_distant" },
  { label: "障害物除去不十分（草木 等）", value: "obstruction_not_removed" },
  { label: "報告設備誤り", value: "incorrect_equipment" },
];

const tepcoBirdNestStatusOption = [
  { label: "写真不良（DEA）", value: "blurry_or_distant_dea", "tip": "関係ない写真等写真が不良のもの（DEA選択）", deaValue: "CROW_NEST_UNCLEAR_IMAGE" },
  { label: "写真不良", value: "blurry_or_distant", "tip": "関係ない写真等写真が不良のもの",  deaValue: "CROW_NEST_UNCLEAR_IMAGE" },
  { label: "営巣なし", value: "no_birdnest", "tip": "写真を確認した結果、営巣がなかったもの",  deaValue: "NO_CROW_NEST" },
  { label: "残置対応 - 机上確認", value: "desk_check", "tip": "写真のみで、営巣の残置対応が可能と判断したもの" },
  { label: "撤去対応 - 机上確認", value: "desk_removal", "tip": "写真のみで、営巣の撤去対応が必要と判断したもの" },
  { label: "現地確認依頼中", value: "inquiry", "tip": "写真を確認した結果、現地で詳細確認が必要と判断したもの" },
  { label: "残置対応 - 現地確認", value: "field_check", "tip": "写真で営巣は確認できたものの、現地での詳細確認の結果残置対応が可能と判断したもの" },
  { label: "撤去対応 - 現地確認", value: "field_removal", "tip": "写真で営巣は確認できたものの、現地での詳細確認の結果残置対応が可能と判断したもの" },
];

const tepcoBirdNestAngleIdConfig = [
  { angleId: "54", keywords: ["全景"] },
  { angleId: "57", keywords: ["電柱番号"] },
  { angleId: "58", keywords: ["カラスの巣①", "カラスの巣1", "カラスの巣 1", "鳥の巣①", "鳥の巣1", "鳥の巣 1"] },
  { angleId: "59", keywords: ["カラスの巣②", "カラスの巣2", "カラスの巣 2", "鳥の巣②", "鳥の巣2", "鳥の巣 2"] },
];

export default {
  tagCategory,
  seasonTag,
  missionTagB,
  missionTagC,
  reportTag,
  reportTag2,
  reportResultTagTemp,
  reportResultTagTemp2,
  reportResultTagTip,
  resultTagNtt,
  nttmeRejectReasons,
  resultTagNttOption,
  tepcoBirdNestStatusOption,
  tepcoBirdNestAngleIdConfig,
}
